(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

        closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close && disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vivid-benefits"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var tracks = document.querySelectorAll('.vbenefits__track');

    tracks.forEach(function (track) {
      var sectionId = track.id.replace('vbenefits-track-', '');
      var dotsEl = document.getElementById('vbenefits-dots-' + sectionId);

      var total = track.children.length;
      if (total === 0) return;

      // Nur auf Mobile aktiv (Desktop hat transform: none !important)
      var mq = window.matchMedia('(max-width: 749px)');
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var cardWidth = parseInt(track.dataset.cardWidth, 10) || 160;
      var steps = parseInt(track.dataset.steps, 10) || 1;
      var current = 0;
      var timer = null;

      function goTo(i) {
        if (i < 0) i = 0;
        if (i > steps - 1) i = steps - 1;
        current = i;

        track.classList.add('is-animating');
        track.style.transform = 'translateX(-' + (current * cardWidth) + 'px)';

        // will-change wieder entfernen nach Animation
        setTimeout(function () {
          track.classList.remove('is-animating');
        }, 600);

        updateDots();
      }

      function updateDots() {
        if (!dotsEl) return;
        var dots = dotsEl.children;
        for (var i = 0; i < dots.length; i++) {
          if (i === current) {
            dots[i].classList.add('vbenefits__dot--active');
            dots[i].setAttribute('aria-current', 'true');
          } else {
            dots[i].classList.remove('vbenefits__dot--active');
            dots[i].removeAttribute('aria-current');
          }
        }
      }

      function attachDotClicks() {
        if (!dotsEl) return;
        Array.prototype.forEach.call(dotsEl.children, function (dot, idx) {
          dot.addEventListener('click', function () {
            stopAuto();
            goTo(idx);
            startAuto();
          });
        });
      }

      function startAuto() {
        if (reducedMotion || !mq.matches) return;
        stopAuto();
        timer = setInterval(function () {
          var next = current + 1;
          if (next > steps - 1) next = 0;
          goTo(next);
        }, 3500);
      }

      function stopAuto() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      // Touch-Swipe
      var startX = 0;
      track.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        stopAuto();
      }, { passive: true });

      track.addEventListener('touchend', function (e) {
        var diff = startX - e.changedTouches[0].clientX;
        if (diff > 40) goTo(current + 1);
        else if (diff < -40) goTo(current - 1);
        startAuto();
      }, { passive: true });

      // Auto-Rotate pausieren wenn Tab im Hintergrund
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stopAuto();
        else startAuto();
      });

      // Bei Resize zwischen Mobile/Desktop neu evaluieren
      mq.addEventListener('change', function () {
        if (mq.matches) {
          startAuto();
        } else {
          stopAuto();
          goTo(0); // Reset
        }
      });

      attachDotClicks();
      startAuto();
    });
  })();

  /* ── Scroll-Reveal der Karten (vereinheitlicht über alle VIVID-Sektionen) ── */
  (function () {
    var roots = document.querySelectorAll('.vbenefits');
    if (!roots.length) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    roots.forEach(function (root) {
      if (reduce || !('IntersectionObserver' in window)) {
        root.classList.add('is-revealed');
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            root.classList.add('is-revealed');
            io.disconnect(); // nur einmal animieren
          }
        });
      }, { threshold: 0.15 });

      io.observe(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
